import { ReactElement, useCallback, useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { differenceInSeconds } from 'date-fns';

import { useGlobalTranslation } from 'modules/i18n/hooks/useGlobalTranslation';

import { translation } from './translation';
import { useStyles } from './useStyles';

interface IExploreProps {
  startDate: Date;
}

export function formatTime(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  return `${String(hours).padStart(2, '0')}h : ${String(minutes).padStart(2, '0')}m : ${String(secs).padStart(2, '0')}s`;
}

export function RatioLastUpdate({ startDate }: IExploreProps): ReactElement {
  const { t, keys } = useGlobalTranslation(translation);
  const { classes } = useStyles();

  const [elapsedTime, setElapsedTime] = useState<string>('00h : 00m : 00s');

  const updateElapsedTime = useCallback(() => {
    const secondsElapsed = differenceInSeconds(new Date(), startDate);
    setElapsedTime(formatTime(secondsElapsed));
  }, [startDate]);

  useEffect(() => {
    const intervalId = setInterval(updateElapsedTime, 1000);

    updateElapsedTime();

    return () => clearInterval(intervalId);
  }, [updateElapsedTime]);

  return (
    <div className={classes.root}>
      <div className={classes.info}>
        <Typography
          color={theme => theme.palette.text.secondary}
          fontWeight={600}
          variant="body1"
        >
          {t(keys.title)}
        </Typography>
      </div>

      <Typography fontSize={18} fontWeight={600}>
        {elapsedTime}
      </Typography>
    </div>
  );
}
